<template>
    <div>
        <v-card>
            <s-toolbar label="Asistencia Remota" dark color="#8e8f91">
                <!-- <v-tooltip bottom="">
                    <template v-slot:activator="{ on }">
                        <v-btn 
                            v-on="on"
                            text
                            black
                            small
                        > 
                            <i class="fas fa-stopwatch"></i> {{ timer.display }}
                        </v-btn>
                    </template>
                    <span>Tiempo</span>
                </v-tooltip> -->
            </s-toolbar>
            <v-container>
                <v-row>
                    <v-col>
                        <v-data-table
                            item-key="RtwID"
                            dense
                            fixed-header
                            :items="items"
                            :headers="config.headers"
                            :items-per-page="10"
                            v-model="selected"
                        >
                        <template v-slot:[`item.Assistance`]="{ item }">
                            <!-- Mostrar botones solo si NO ha completado ambas marcas -->
                            <template v-if="item.HasCompletedAttendance === 0 && item.AttendanceState !== 'I' && item.BelongsTo === 1 && $fun.formatDateView(item.RtwDate) === $fun.formatDateView(item.CurrentDate)">
                                <v-btn      
                                    v-if="item.AttendanceState === 'E'" 
                                    x-small 
                                    color="info" 
                                    @click="RegisterAttendance(item)"
                                >
                                    <v-icon>mdi-play-circle</v-icon> Entrada
                                </v-btn>

                                <v-btn 
                                    v-if="item.AttendanceState === 'S'" 
                                    x-small 
                                    color="error" 
                                    @click="RegisterAttendance(item)"
                                >
                                    <v-icon>mdi-stop-circle</v-icon> Salida
                                </v-btn>
                            </template>

                            <template v-else-if="item.HasCompletedAttendance === 1">
                                <v-chip color="success" x-small dark>
                                    <v-icon left>mdi-check-circle</v-icon>
                                    Asistió
                                </v-chip>
                            </template>

                            <template v-else-if="item.AttendanceState === 'I' && item.AttendanceCount === 0">
                                <v-chip color="red" x-small dark>
                                    <v-icon left>mdi-close-circle</v-icon>
                                    Inasistencia
                                </v-chip>
                            </template>
                        </template>

                        <template v-slot:[`item.RtwDate`]="{ item }">
                            {{ $fun.formatDateView(item.RtwDate) }}
                        </template>
                        <template v-slot:[`item.TdrDateBegin`]="{ item }">
                            {{ $fun.formatDateTimeView(item.TdrDateBegin) }}
                        </template>
                        <template v-slot:[`item.TdrDateEnd`]="{ item }">
                            {{ $fun.formatDateTimeView(item.TdrDateEnd) }}
                        </template>
                        <template v-slot:[`item.TdrTimeBegin`]="{ item }">
                            {{ $fun.formatTimeView(item.TdrDateBegin) }}
                        </template>
                        <template v-slot:[`item.TdrTimeEnd`]="{ item }">
                            {{ $fun.formatTimeView(item.TdrDateEnd) }}
                        </template>

                        <template v-slot:[`item.Actions`]="{ item }">
                            <v-btn
                                icon
                                small
                                color="primary"
                                class="mb-1"
                                @click="openTasksDialog(item, false, true)"
                                v-if="(
                                        item.BelongsTo === 1 && item.AttendanceCount > 0 && isWithinOneDay(item.CurrentDate, item.TdrDateEnd, item.SecCreate)
                                    )"
                            >
                                <v-icon>mdi-file-document-plus</v-icon>
                            </v-btn>
                            <v-btn
                                icon
                                small
                                color="primary"
                                @click="openTasksDialog(item, false, false)"
                                class="mb-1"
                                v-else-if="(
                                        item.BelongsTo === 1 && !isWithinOneDay(item.CurrentDate, item.TdrDateEnd, item.SecCreate)
                                    )"
                            >
                                <v-icon>mdi-file-star-four-points-outline</v-icon>
                            </v-btn>
                            <v-btn
                                icon
                                small
                                color="cyan darken-4"
                                dark
                                class="mb-1"
                                @click="editRemoteWorkDialog(item)"
                                v-if="(
                                        isWithinOneDay(item.CurrentDate, item.TdrDateEnd, item.SecCreate)
                                    )"
                            >
                                <v-icon v-if="item.BelongsTo === 0">mdi-pencil</v-icon>
                                <v-icon v-else>mdi-fingerprint</v-icon>
                            </v-btn>
                        </template>

                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>

        <v-dialog persistent v-if="openDialog" v-model="openDialog" max-width="600px">
           <s-Tasks :item="newData" :approval="approval" :edit="editTasks" @close="close"></s-Tasks>
        </v-dialog>

        <v-dialog v-model="showEditMarking" v-if="showEditMarking" persistent max-width="900">
            <v-card>
                <div style="padding: 16px 24px 10px">
                    <s-crud
                        :edit="this.editRemoteWork.BelongsTo === 0"
                        :add="this.editRemoteWork.BelongsTo === 0"
                        @save="save($event)"
                        height="auto"
                        title="Marcaciones de Trabajo Remoto"
                        :config="configAttendance"
                        :filter="filterAttendance"
                        searchInput
                        close
                        @close="closeEditMarking()"
                    >
                    <template scope="props">
                        <v-container>
							<v-row >
								<v-col cols="6">
									<div>
										<s-select-definition class="s-col-form" :def="1527" label="Estado Marcación" v-model="props.item.TdrTypeMarking"></s-select-definition>
									</div>
								</v-col>
								
								<v-col cols="6">
									<div>
										<s-date class="s-col-form" type="datetime" label="Marcación" v-model="props.item.TdrDateMarking"></s-date>
									</div>
								</v-col>
                                <v-col cols="12">
									<div>
										<s-text class="s-col-form" label="Observaciones" v-model="props.item.TdrObservation"></s-text>
									</div>
								</v-col>
                            </v-row>
                        </v-container>
                    </template>
                    <template v-slot:TdrStatusMarking="{ row }">
                        <v-chip x-small :color="row.MrkID === null ? 'orange' : 'green'" dark>{{ row.MrkID === null ? 'Por aprobar' : 'Aprobado' }}</v-chip>
                    </template>
                    </s-crud>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import { _ } from 'core-js';
import SText from '@/components/Utils/SText.vue';
import sTasks from '@/components/Utils/RecursosHm/sTasks.vue';
import _sAttendanceRemoteService from '@/services/HumanResource/Compensation/HmnAttendanceRemoteService.js';

export default {
    components: {
        SText,
        sTasks
    },
    data() {
        return {
            items: [],
            selected: [],
            obj: {},
            filter: {
                WkrID: 0
            },
            filterAttendance: {
                RtwID: 0
            },
            timer: {
                hours: 0,
                minutes: 0,
                seconds: 0,
                interval: null,
                display: "00:00:00", // Añadimos una propiedad para el display
                startDate: null      // Fecha de inicio para el cronómetro
            },
            entryDate: null,
            exitDate: null,
            openDialog: false,
            newData: {},
            approval: false,
            editTasks: false,
            showEditMarking: false,
            editRemoteWork: {},
            config: {
                headers: [
                    {text: "ID"									, value: "RtwID"				},
                    {text: "N° Doc"								, value: "PrsDocumentNumber"	},
                    {text: "Nombres y Apellidos Completos"		, value: "NtpFullName"			},
                    {text: "Descripcion"		                , value: "RtwDescription"		},
                    {text: "Area"								, value: "AreName"				},
                    {text: "Fecha de programación"			    , value: "RtwDate"			    },
                    {text: "Fecha Entrada"			            , value: "TdrDateBegin"		    },
                    {text: "Fecha Salida"			            , value: "TdrDateEnd"		    },
                    {text: "Asistencia"			                , value: "Assistance"			},
                    {text: "Acciones"			                , value: "Actions"			    },
                ],
            },
            configAttendance: {
                service: _sAttendanceRemoteService,
                model: {
                    TdrID: "ID",
                    TdrDateMarking: "datetime",
                },
                headers: [
                    {text: "ID"									, value: "TdrID"				},
                    {text: "N° Doc"								, value: "PrsDocumentNumber"	},
                    {text: "Nombres y Apellidos Completos"		, value: "NtpFullName"			},
                    {text: "Tipo Marcación"			            , value: "TdrTypeAttendanceName"},
                    {text: "Asistencia"			                , value: "TdrDateMarking"		},
                    {text: "Observacion"			            , value: "TdrObservation"		},
                    {text: "Estado"			                    , value: "TdrStatusMarking"		},
                ],
            },
        };
    },
    methods: {
        load() {
            _sAttendanceRemoteService
            .list(this.filter, this.$fun.getUserID())
            .then((r) => {
                this.items = r.data;
            });
        },
        
        // Método para iniciar el cronómetro
        // startTimer(startDateString) {
        //     // Guardamos la fecha de inicio
        //     this.timer.startDate = new Date(startDateString);
            
        //     // Detenemos cualquier intervalo existente
        //     if (this.timer.interval) {
        //         clearInterval(this.timer.interval);
        //     }
            
        //     // Función para actualizar el cronómetro
        //     const updateTimer = () => {
        //         const now = new Date();
        //         const diff = now - this.timer.startDate; // diferencia en milisegundos
                
        //         // Convertir a horas, minutos y segundos
        //         const hours = Math.floor(diff / 3600000);
        //         const minutes = Math.floor((diff % 3600000) / 60000);
        //         const seconds = Math.floor((diff % 60000) / 1000);
                
        //         // Actualizar el estado
        //         this.timer.hours = hours;
        //         this.timer.minutes = minutes;
        //         this.timer.seconds = seconds;
                
        //         // Formatear para mostrar (con ceros a la izquierda)
        //         this.timer.display = 
        //             `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        //     };
            
        //     // Ejecutar inmediatamente y luego cada segundo
        //     updateTimer();
        //     this.timer.interval = setInterval(updateTimer, 1000);
        // },
        RegisterAttendance(item) {
            this.obj = {
                RtwID: item.RtwID,
                WkrID: item.WkrID,
                NtpID: this.$fun.getUserInfo().NtpID,
                TdrTypeAttendance: item.AttendanceState,
                UsrCreateID: this.$fun.getUserID()
            }
            this.$fun.alert(`¿Estas seguro de registrar?`, "question")
            .then((val) => {
                if (val.value) {
                    _sAttendanceRemoteService
                        .save(this.obj, this.$fun.getUserID())
                        .then((r) => {
                            this.$fun.alert("Se agrego correctamente", "success");
                            this.load();
                        })
                }
            });
        },
        openTasksDialog(item, approval, edit) {
            this.openDialog = true;
            this.newData = {};
            this.approval = approval;
            this.editTasks = edit;
            this.newData.RtwID = item.RtwID;
        },
        close() {
            this.openDialog = false;
            this.newData = {};
        },
        isWithinOneDay(currentDateStr, endDateStr, secCreate) {

            if(endDateStr == null){
                endDateStr = secCreate;
            }

            if(!endDateStr && currentDateStr) return true;
            if (!currentDateStr) return false;
            
            const current = new Date(currentDateStr);
            const end = new Date(endDateStr);

            const diffInMs = current - end;
            const diffInHours = diffInMs / (1000 * 60 * 60);
            console.log(diffInHours <= 24);
            return diffInHours <= 24;
        },
        editRemoteWorkDialog(item) {
            this.editRemoteWork = {};
            this.editRemoteWork = item;
            this.filterAttendance.RtwID = item.RtwID;
            this.showEditMarking = true;
        },
        closeEditMarking() {
            this.showEditMarking = false;
            this.editRemoteWork = {};
        },
        save(item) {
            console.log("item", item);
            if(item.TdrID === 0){
                item.RtwID = this.editRemoteWork.RtwID;
                item.WkrID = this.editRemoteWork.WkrID;
                item.NtpID = this.editRemoteWork.NtpID;
            }

            // item.RtwID = this.editRemoteWork.RtwID;
            // item.TdrTypeAttendance = this.editRemoteWork.AttendanceState;
            // item.WkrID = this.editRemoteWork.WkrID;
            // item.NtpID = this.editRemoteWork.NtpID;
            item.save();
        }
    },
    mounted() {
        this.filter.NtpID = this.$fun.getUserInfo().NtpID;
        this.load();
    },
    // beforeDestroy() {
    //     if (this.timer.interval) {
    //         clearInterval(this.timer.interval);
    //     }
    // }
}
</script>
